import { Button, RadioGroup, ResponsiveSection, Stack, Text } from '@stitch-fix/mode-react';
import { Dispatch, SetStateAction, useState } from 'react';
import { useClientAuth } from '@stitch-fix/sf-next';
import { useSelectEvent } from '@stitch-fix/event-reporter';
import { useRouter } from 'next/router';
import { GetClientEmailOptOutQuery } from '../GetClientEmailOptOut';
import { ClientEmailOptOutUpdateMutation, useClientEmailOptOutUpdateMutation } from '../ClientEmailOptOutUpdateMutation';
type EmailPreferencesProps = {
  data: GetClientEmailOptOutQuery | undefined;
  setShowErrorToast: Dispatch<SetStateAction<boolean>>;
  setShowSuccessToast: Dispatch<SetStateAction<boolean>>;
};
export const EmailPreferences = ({
  data,
  setShowErrorToast,
  setShowSuccessToast
}: EmailPreferencesProps) => {
  const {
    authStatus
  } = useClientAuth();
  const loggedIn = authStatus === 'authenticated';
  const options = [{
    value: 'opt_in',
    label: 'Exclusive offers, news, styling tips and more!'
  }, {
    value: 'opt_out',
    label: 'No emails, please'
  }];
  const optOut = data?.client?.notificationPreference?.emailOptOut || false;
  const emailPreferenceValue: string = optOut ? 'opt_out' : 'opt_in';
  const [emailPreference, setEmailPreference] = useState(emailPreferenceValue);
  const router = useRouter();
  const emailFromParams = router.query.email !== undefined ? router.query.email.toString() : null;

  // Legacy before sf_client_external_id
  const externalIdFromParams = router.query.external_id !== undefined ? router.query.external_id.toString() : null;
  const sfClientExternalIdFromParams = router.query.sf_client_external_id !== undefined ? router.query.sf_client_external_id.toString() : null;
  const tokenFromParams = router.query.bsft_auth !== undefined ? router.query.bsft_auth.toString() : null;
  const {
    reportSelectEvent
  } = useSelectEvent();
  const [updateClientEmailOptOutMutation, {
    loading: loadingClientEmailOptOutMutation
  }] = useClientEmailOptOutUpdateMutation({
    variables: {
      input: {
        optOut: emailPreference === 'opt_out',
        token: tokenFromParams,
        email: emailFromParams,
        externalId: externalIdFromParams || sfClientExternalIdFromParams
      }
    },
    onCompleted: ({
      clientNotificationEmailOptOutUpdate
    }: ClientEmailOptOutUpdateMutation) => {
      if (!clientNotificationEmailOptOutUpdate?.result) {
        setShowErrorToast(true);
        return;
      }
      const {
        result
      } = clientNotificationEmailOptOutUpdate;
      if ('emailOptOut' in result) {
        setShowSuccessToast(true);
      } else {
        setShowErrorToast(true);
      }
    }
  });
  const onClickSaveButton = () => {
    reportSelectEvent({
      schema: 'select',
      name: 'email_toggle',
      action_name: emailPreference === 'opt_out' ? 'email_opt_out_promotional' : 'email_opt_in_promotional'
    });
    updateClientEmailOptOutMutation();
  };
  return <ResponsiveSection py={1.5}>
      <Stack spacing={1.5}>
        <Text setting="title-large">Email Preferences</Text>
        {loggedIn && <Text setting="body-small">
            Your email address on file is: {data?.client?.email}
          </Text>}
        <Text setting="title-medium">I&apos;d like to receive:</Text>
        <RadioGroup name="EmailPreferences" value={emailPreference} direction="vertical" onChange={value => {
        setEmailPreference(value);
      }} options={options} />
        <Button type="submit" variant="filled-staple" disabled={loadingClientEmailOptOutMutation} onClick={onClickSaveButton}>
          Save
        </Button>
        <Text setting="body-small">
          You can change your preference at any time.
        </Text>
      </Stack>
    </ResponsiveSection>;
};